import { PayloadAction } from '../../../../../store.model';
import { setFocus } from '../function/set-focus.function';
import { ActionType } from '../teamschat-transcript-dialog.action';
import { TeamschatTranscriptDialogState } from '../teamschat-transcript-dialog.state';

import { EditNotesFocus } from './edit-notes-focus.action';

export function editNotesFocusReducer(
    state: TeamschatTranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TCTD__EDIT_NOTES_FOCUS,
        EditNotesFocus
    >,
): TeamschatTranscriptDialogState {
    const cmtNotesFocus = setFocus(
        action.payload.behaviourId,
        action.payload.subBehaviourId,
        state.behaviours,
        state.subBehaviours,
    );

    return {
        ...state,
        cmtNotesFocus,
    };
}
